import React from 'react';
import { Typography } from 'antd';
import { I18n } from '@aws-amplify/core';

import { StepsNavigation } from '@/components/ui/StepsNavigation';
import { useKimLhc } from '@/context/KimLhc';
import type { Steps } from '@/context/KimLhc/types';
import { DIRECTION } from '@/components/ui/StepsNavigation/types';

const { Title } = Typography;

interface HeaderStepProps {
	steps: Steps[];
}

export function HeaderStep({ steps }: Readonly<HeaderStepProps>): JSX.Element {
	const { currentStep, onSetStep } = useKimLhc();

	async function handleOnStepNavigationClick(step: number): Promise<void> {
		onSetStep(step);
	}

	return (
		<>
			<Title level={3} style={{ textAlign: 'center', marginTop: '24px' }}>
				{I18n.get('KIM LHC: Manual lifting, holding, and carrying of loads')}
			</Title>
			<StepsNavigation
				steps={steps}
				isComplete={false}
				currentStep={currentStep}
				onStepNagivationClick={handleOnStepNavigationClick}
				direction={DIRECTION.HORIZONTAL}
			/>
		</>
	);
}
